import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { PasswordFields } from '../components/PasswordFields';
import { LoginAction } from '../enum/LoginAction';
import { UserContext } from '../UserContext';
import { UserModel, userModelInitial } from '../../../Models/UserModel';
import AuthService from '../../../Services/AuthService';
import { AlertDialog, alertDialogPropsInitial, IAlertDialogProps } from '../../../shared/components/AlertDialog';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { AuthContext } from '../../Authentication/AuthContext';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { FirstAccess } from './FirstAccess';
import { LoginInput } from './LoginInput';
import loginLateral from '../../../assets/Login_ImagemLateral.png';
import { SendEmail } from './SendEmail';
import { ConfirmCode } from './ConfirmCode';
import { ChangePassword } from './ChangePassword';
import { LoadingDialog } from '../../../shared/components/LoadingDialog';
import { RecoveryFields } from './RecoveryFields';

export interface IChangePasswordProps {
    onClick: () => void
    onBack: () => void
}

const useStyles = makeStyles(() => createStyles({
    container: {
        width: '430px'
    },
    itens: {        
        marginTop: '20px',
        width: '100%'
    },  
    textLink: {
        margin: '4px',
        cursor: 'pointer'
    },
    root: {
        flexGrow: 1,
    },
    img: {
        width: 'auto',
        height: '100vh',
    }
}));

export function RecoveryPassword() {
    const classes = useStyles();
    const [passsword, setPassword] = React.useState<string>('');
    const [user, setUser] = React.useState<UserModel>(userModelInitial);
    const [alertProps, setAlertProps] = React.useState<IAlertDialogProps>(alertDialogPropsInitial);
    const [openLoadingDialog, setOpenLoadingDialog] = React.useState<boolean>(false);

    const location = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(location.search);
    const token =  params.get('token');

    if (!token ) {
        return <Redirect to="/" />;
    }

    function onChangePassword() {
        AuthService
            .changePassword(user,token as string)
            .then(() => {
                setUser({ ...user, password: null });
                setAlertProps({
                    message: 'Sua nova senha foi salva com sucesso!',
                    severity: 'success',
                    open: true,
                    onClose: () => { setAlertProps({ ...alertProps, open: false }); }
                });
                history.push('/', { from: location });
            })
            .catch((error: AxiosError) => { showError(error, ''); });
    }

    

    const onBack = () => {
        history.push('/', { from: location });
    };


    const showError = (error: AxiosError, message: string) => {
            const errorResponse: IErrorResponse = ErrorHelper(error);
            setAlertProps({
                message: message + errorResponse.message,
                severity: 'error',
                open: true,
                onClose: () => { setAlertProps({ ...alertProps, open: false }); }
            });
        };
    
    return (
        <>
        <div className={classes.root}>
            <Grid
                container
                direction="row"
                alignItems="center"
                justify='space-around'>
                <img className={classes.img} alt="complex" src={loginLateral} />
                    <Grid
                        item
                        xs
                        container
                        direction="column"
                        alignItems="center">
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="flex-start" 
                                className={classes.container}> 
                                <Typography 
                                    variant='subtitle2' 
                                    className={classes.textLink} 
                                    onClick={onBack}>
                                    Voltar
                                </Typography>
                                <Typography 
                                    variant='h3' 
                                    color="textPrimary">
                                    Recuperação de senha
                                </Typography>
                                <Typography 
                                    variant='body1' 
                                    color="textSecondary">
                                    Crie uma nova senha para plataforma de no mínimo 12 digitos.
                                </Typography> 
                                <Grid 
                                    item 
                                    xs={12}>
                                    <RecoveryFields user={user} setUser={setUser}/> 
                                </Grid>
                                <Button 
                                    size="large" 
                                    variant="contained" 
                                    color="primary" 
                                    fullWidth 
                                    className={classes.itens} 
                                    onClick={onChangePassword} 
                                    >
                                    SALVAR NOVA SENHA
                                </Button>
                            </Grid>  
                    </Grid>
            </Grid>
        </div>
        <AlertDialog
            message={alertProps.message}
            onClose={alertProps.onClose}
            open={alertProps.open}
            severity={alertProps.severity} />
        <LoadingDialog open={openLoadingDialog}/>
    </>

    );  
}
